// Feature: sticky brand logo animation - start
(function () {
  var markerSelector = '[data-brand-logo-marker]';
  var activeClass = 'brand-logo-animation-active';
  var visibleClass = 'brand-logo-animation-visible';
  var passedClass = 'brand-logo-animation-passed';
  var frameId = null;

  function updateLogoState() {
    frameId = null;

    var markers = Array.prototype.slice.call(document.querySelectorAll(markerSelector));
    var header = document.querySelector('[data-header-height]');
    var body = document.body;

    if (!body || !header || !markers.length) {
      if (body) {
        body.classList.remove(activeClass, visibleClass, passedClass);
      }
      return;
    }

    var headerHeight = header.getBoundingClientRect().height;
    var largeLogoVisible = false;
    var largeLogoPassed = false;

    markers.forEach(function (marker) {
      var rect = marker.getBoundingClientRect();

      if (rect.bottom > headerHeight && rect.top < window.innerHeight) {
        largeLogoVisible = true;
      }

      if (rect.bottom <= headerHeight) {
        largeLogoPassed = true;
      }
    });

    body.classList.add(activeClass);
    body.classList.toggle(visibleClass, largeLogoVisible);
    body.classList.toggle(passedClass, !largeLogoVisible && largeLogoPassed);
  }

  function requestUpdate() {
    if (frameId !== null) return;
    frameId = window.requestAnimationFrame(updateLogoState);
  }

  function initLogoAnimation() {
    requestUpdate();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLogoAnimation, { once: true });
  } else {
    initLogoAnimation();
  }

  document.addEventListener('shopify:section:load', requestUpdate);
  document.addEventListener('shopify:section:unload', requestUpdate);
  document.addEventListener('shopify:section:reorder', requestUpdate);
}());
// Feature: sticky brand logo animation - end
